import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoRootModule } from '../../../app/transloco/transloco-root.module';
import { HeaderComponent } from './header.component';

@NgModule({
	imports: [CommonModule, MatButtonModule, MatIconModule, TranslocoRootModule, HeaderComponent],
	declarations: [],
	exports: [HeaderComponent],
})
export class HeaderModule {}
